import { OverlapElementTree } from './search-elements-tree.model';

export class SearchOverlap {
  itemId: string;
  overlapsCount: number;
  object: any;
  overlapElementTree: OverlapElementTree[];
}

export class SearchOverlapsFoundEvent {
  constructor(readonly overlaps: SearchOverlap[]) {}
}
